angular.module('bribac.service.datePickerService',[])
.factory("datePickerService", function($rootScope) {
    var obj = {}
    obj.changeDate = null
    obj.monthChanged = function(date) {
      $rootScope.$broadcast('monthChanged',date);
    }
    return obj
})